import type { ReactNode } from 'react';
import { Badge } from '@mantine/core';

interface MetaChipProps {
  readonly icon?: ReactNode;
  readonly children: ReactNode;
}

// Чип характеристики-метаданного (протеин, тоннаж, базис, качество): мягкий серый по таксономии
// бейджей. Единый вид везде (дашборд, сводка сделки, карточка оффера). Ранее дублировался.
export default function MetaChip({ icon, children }: MetaChipProps) {
  return (
    <Badge
      variant="light"
      color="gray"
      size="sm"
      radius="sm"
      tt="none"
      fw={500}
      leftSection={icon}
      styles={{ label: { fontSize: 'var(--mantine-font-size-xs)', overflow: 'visible' } }}
    >
      {children}
    </Badge>
  );
}
